import { GeolocalisationMap } from './Geolocalisation.Map';
import { SettingsLayout } from 'views/settings';

export { GeolocalisationLayout };

function GeolocalisationLayout() {
    return (
        <>  
            <SettingsLayout />
            <GeolocalisationMap />
        </>
        
    );
}
